// Action Types
import AnalyticsTypes from '~/constants/types/AnalyticsTypes';

const Notes = {
  start: () => ({
    event: 'lab_notes_start'
  }),
  add: () => ({
    event: 'lab_notes_added'
  })
};

const NotesEvents = {
  [AnalyticsTypes.NOTES]: Notes.start,
  [AnalyticsTypes.NOTES_ADDED]: Notes.add
};

export default NotesEvents;
